import MenuContentRow from './MenuContentRow'

export default MenuContentRow
